<template>
  <!-- 说明：这个组件一定要配合 .pic-holder 父容器的div来用 -->
  <div class="media-box">
    <span v-if="!src"></span>

    <video 
      v-else-if="src && src.indexOf('.mp4') >0"
      loop
      autoplay
      muted
      controls
      :src="src"
    ></video>

    <audio 
      v-else-if="src && src.indexOf('.mp3') >0"
      :src="src"
      controls
    ></audio>

    <img 
      v-else
      :src="src"
    >
  </div>
</template>

<script>

export default {
  name: 'nftCoverImg',
  components: {},
  props: [
    'src',
  ],
  data() {
    return {
      
    }
  },
  computed: {},
  watch: {},
  methods: {
    
  },
  created() {
    return
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>

</style>